import ReactOnRails from 'react-on-rails';
import CotiousWebsiteApp from '../bundles/CotiousWebsite/components/CotiousWebsiteApp';

ReactOnRails.register({
  CotiousWebsiteApp,
});
